import { notifications } from '@mantine/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const mutateFontCreate = () => {

    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationKey: ['font-create'],
        mutationFn: async ({ name, data }) => {
            const res = await axios.post(route('studio.v1.api.fonts.store'), { name, data });
            return res;
        },
        onSuccess: async () => {
            queryClient.invalidateQueries({ queryKey: ['studio-custom-fonts'] });
            notifications.show({
                color: 'green',
                title: 'Success',
                message: 'Font uploaded',
            })
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
